module.exports = __webpack_public_path__ + "img/27600.0035c216.jpg";